import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Buscás material y encontrás textos genéricos sin ejemplos argentinos', 'Armás actividades desde cero cada trimestre perdiendo horas que no tenés', 'Tus alumnos preguntan por el Riachuelo, el Paraná o el Guaraní y no tenés datos precisos a mano', 'No contás con mapas didácticos de cuencas argentinas listos para el aula', 'Llegás al domingo a la noche buscando evaluaciones para el lunes', 'Tus planificaciones anuales las rehacés cada año porque no tenés un sistema', 'Querés hacer proyectos para la Feria de Ciencias pero no sabés por dónde empezar', 'Sentís que el material disponible no está a la altura de lo que tus alumnos merecen'];
  return <section className="py-20 bg-[#0a1428]" data-id="element-296">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-298">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-299">
            ❓ ¿Cuántas clases más vas a preparar sin tener el material
            resuelto?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center max-w-3xl mx-auto" data-id="element-300">
            <p className="text-[14px]" data-id="element-301">
              Tal vez ya buscaste en YouTube y encontraste videos en inglés
              sobre hidrología genérica que no aplica a Argentina. Tal vez armás
              tus actividades desde cero cada año. Tal vez cuando un alumno
              pregunta por el Acuífero Guaraní o la bajante del Paraná no tenés
              una respuesta con datos reales.
            </p>
            <p data-id="element-302">
              <strong className="text-white text-[16px]" data-id="element-303">
                No es falta de preparación. Es que nadie armó el sistema
                completo para docentes argentinos de hidrología.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0f1d35]/80 border border-slate-500/30 rounded-2xl p-6 md:p-8" data-id="element-304">
          <h3 className="text-xl font-bold text-slate-200 mb-6 text-center" data-id="element-305">
            😓 Esto te está pasando ahora mismo:
          </h3>
          <ul className="space-y-4" data-id="element-306">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-307">
                <div className="mt-1 bg-slate-700/50 p-1 rounded-full shrink-0 border border-slate-500/50" data-id="element-308">
                  <X className="w-4 h-4 text-slate-300" data-id="element-309" />
                </div>
                <span className="text-slate-200 font-medium text-[14px]" data-id="element-310">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-311">
          <p className="font-bold text-slate-300 text-[16px]" data-id="element-312">
            🎯 ¿Y si esta fuera la última semana que preparás clases sin tener
            todo el contenido resuelto?
          </p>
        </div>
      </div>
    </section>;
}